import React from 'react';

import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import ProjectsCard from "./ProjectsCard";

//JavaScript Projects Images
import CardPic from '../assets/img/3dcards-JS.PNG';
import ChatJS from '../assets/img/ChatApp-JS.PNG';
import GlassWeb from '../assets/img/Glass-JS.PNG';
import Personal from '../assets/img/personal-JS.PNG';
import SaylaniTask from '../assets/img/saylaniTask-JS.PNG';
import SnakeApp from '../assets/img/snake-JS.PNG';

//ReactJS Projects Images
import ChatApp from '../assets/img/ChatApp-pic-R.PNG';
import HWSM from '../assets/img/HWSM-pic-R.PNG';
import Olx from '../assets/img/Olx-pic-R.PNG';
import pakShop from '../assets/img/pak-shop-pic-R.PNG';
import todoApp from '../assets/img/todoapp-pic-R.PNG';
import WApp from '../assets/img/Weatherapp-pic-R.PNG';
import colorSharp2 from "../assets/img/color-sharp2.png";
import HRDashboard from '../assets/img/HRDashboard.PNG';
import MernChatApp from '../assets/img/mernChatApp.PNG';
import YelliyhDashboard from '../assets/img/YelliyhDashboard.PNG';


// Designing Projects
import CVWaleed from '../assets/img/CV-Waleed.jpg';
import HLogo4 from '../assets/img/HLogo4.PNG';
import idacard from '../assets/img/idacard-N.PNG';
import LogoN from '../assets/img/Logo-N.PNG';

const Projects = () => {
    //JavaScripts Projects
    const projectsJS = [
        {
            title: '3D Card',
            desc: 'Creating 3D Card Style Applications using JavaScript',
            imgURL: CardPic
        },
        {
            title: 'Chat Application',
            desc: 'Creating Chat Application Using Plain JavaScript',
            imgURL: ChatJS
        },
        {
            title: 'Glass View Website',
            desc: 'Create Glass View Smooth Website Using JavaScript',
            imgURL: GlassWeb
        },
        {
            title: 'Personal Portfolio',
            desc: 'Create Personal Portfolio Using HTML, CSS and JavaScript',
            imgURL: Personal
        },
        {
            title: 'Saylani Task Web Application',
            desc: 'Create Saylani Task Website to Store Saylani Assignments',
            imgURL: SaylaniTask
        },
        {
            title: 'Snake Game',
            desc: 'Create Simple Snake Game Using Plain JavaScript',
            imgURL: SnakeApp
        }
    ]
    //ReactJS Projects
    const projects = [
        {
            title: 'Chat App',
            desc: 'Create Chat App with ReactJS',
            imgURL: ChatApp
        },
        {
            title: 'HWSM Website',
            desc: 'Create Banking Website Using ReactJS and Firebase',
            imgURL: HWSM
        },
        {
            title: 'OLX Website',
            desc: 'OLX Replica using ReactJS and Firebase Database & Auth',
            imgURL: Olx
        },
        {
            title: 'Mern Ecommerce',
            desc: 'Create Ecommerce Website using Mern Stack Technology',
            imgURL: pakShop
        },
        {
            title: 'TodoApp Application Developement',
            desc: 'Create todo Application using ReactJS and Database',
            imgURL: todoApp
        },
        {
            title: 'Weather Application Developement',
            desc: 'Create Weather Application using ReactJS and OpenWeather API',
            imgURL: WApp
        },
        {
            title: 'Dashboard With Context API',
            desc: 'Create Dashboard Using ReactJS, Material UI & Icons and Canvasjs',
            imgURL: HRDashboard
        },
        {
            title: 'Mern Chat App',
            desc: 'Create Mern Stack Chat App With Socket',
            imgURL: MernChatApp
        },
        {
            title: 'Dashboard With Context API',
            desc: 'Create Dashboard Using ReactJS, Material UI & Icons and Canvasjs',
            imgURL: YelliyhDashboard
        }
    ]

    // Designs Projects
    const designsProject = [
        {
            title: 'CV Using',
            desc: 'Creating CV/Resume Using PhotoShops & Illustrator',
            imgURL: CVWaleed
        },
        {
            title: 'Product',
            desc: 'Creating CV/Resume Using PhotoShops & Illustrator',
            imgURL: LogoN
        },
        {
            title: 'ID Cards',
            desc: 'Creating ID Cards For any Product & Organization',
            imgURL: idacard
        },
        {
            title: 'Product Logo',
            desc: 'Creating AutoMobil Relate Porducts Logos',
            imgURL: HLogo4
        }
    ]

    return (
        <section className="project" id="project">
            <Container>
                <Row>
                    <Col size={12}>
                        <h2>Projects</h2>
                        <p>My Previous Work</p>
                        <Tab.Container id="projects-tabs" defaultActiveKey="first">
                            <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                                <Nav.Item>
                                    <Nav.Link eventKey="first">Plain JavaScript</Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="second">ReactJS</Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="third">Designing</Nav.Link>
                                </Nav.Item>
                            </Nav>
                            {/* className={isVisible ? "animate__animated animate__slideInUp" : ""} */}
                            <Tab.Content id="slideInUp">
                                <Tab.Pane eventKey="first">
                                    <Row>
                                        {
                                            projectsJS.map((project, index) => {
                                                return (
                                                    <ProjectsCard
                                                        key={index}
                                                        {...project}
                                                    />
                                                )
                                            })
                                        }
                                    </Row>
                                </Tab.Pane>
                                <Tab.Pane eventKey="second">
                                    <Row>
                                        {
                                            projects.map((project, index) => {
                                                return (
                                                    <ProjectsCard
                                                        key={index}
                                                        {...project}
                                                    />
                                                )
                                            })
                                        }
                                    </Row>
                                </Tab.Pane>
                                <Tab.Pane eventKey="third">
                                    <Row>
                                        {
                                            designsProject.map((project, index) => {
                                                return (
                                                    <ProjectsCard
                                                        key={index}
                                                        {...project}
                                                    />
                                                )
                                            })
                                        }
                                    </Row>
                                </Tab.Pane>
                            </Tab.Content>
                        </Tab.Container>
                    </Col>
                </Row>
            </Container>
            <img className="background-image-right" src={colorSharp2} alt="Background"></img>
        </section>
    )
}

export default Projects;